import React from 'react';
import "./MasterManagementPage.css";
import NavBar from '../../components/NavBar';
import { uploadData } from 'aws-amplify/storage';
import { useGeneralSetting } from '../../context/GeneralSettingContext';
import FanLoadingIcon from '../../components/FanLoadingIcon';
import { useSensorGroups } from '../../context/SensorGroupsContext';
import SensorGroupList from './components/SensorGroupList';
import ModifyGroupForm from './components/ModifyGroupForm';
import { useDialog } from '../../context/DialogContext';
import { apiCreateGroup, apiDeleteGroup, apiUpdateGroup } from '../../apis/SensorApi';
import { DIALOG_ERROR_GENERAL_ERROR_MESSAGE, DIALOG_MESSAGE_CONFIRM_DELETE_GROUP, DIALOG_MESSAGE_CONFIRM_DELETE_NOTIFICATION, DIALOG_MESSAGE_CREATED_NOTIFICATION_SUCCESSFULLY, DIALOG_MESSAGE_UPDATED_GENERAL_SETTING_SUCCESSFULLY, DIALOG_MESSAGE_UPDATED_NOTIFICATION_SUCCESSFULLY, TEXT_CREATE_NEW, TEXT_MASTER_MANAGEMENT, TEXT_MESSAGE_MANAGEMENT, TEXT_NOTIFICATION_MANAGEMENT, TEXT_EMERGENCY_ROUTE_MANAGEMENT, DIALOG_MESSAGE_EMERGENCY_ROUTE_UPLOADED, DIALOG_MESSAGE_EMERGENCY_ROUTE_SAVED, DIALOG_ERROR_EMERGENCY_ROUTE_UPLOAD, DIALOG_ERROR_EMERGENCY_ROUTE_SAVE, DIALOG_MESSAGE_CONFIRM_DELETE_ROUTE, DIALOG_ERROR_EMERGENCY_ROUTE_MAX_LIMIT } from 'constants/message';
import ModifyGeneralSettingForm from './components/ModifyGeneralSettingForm';
import NotificationList from './components/NotificationList';
import { useNotifications } from 'context/NotificationContext';
import { apiCreateNotification, apiDeleteNotification, apiUpdateNotification } from 'apis/NotificationApi';
import ModifyNotificationForm from './components/ModifyNotificationForm';
import EmergencyRouteUpload from './components/EmergencyRouteUpload';
import EmergencyRouteList from './components/EmergencyRouteList';
import { apiSaveEmergencyRoutes, apiUploadEmergencyRouteCSV } from '../../apis/EmergencyRouteApi';
import { useGeoCoordinate } from '../../context/GeoCoordinateContext';
import { useAuth } from 'context/AuthContext';

const TAB_GENERAL = '一般';
const TAB_MESSAGE = TEXT_MESSAGE_MANAGEMENT;
const TAB_NOTIFICATION = TEXT_NOTIFICATION_MANAGEMENT;
const TAB_EMERGENCY_ROUTE = TEXT_EMERGENCY_ROUTE_MANAGEMENT;


const propTypes = {};
const defaultProps = {};
const MasterManagementPage = (props) => {
  /*** States and Variables ***/
  const { error, success, warningConfirm } = useDialog();
  const [loading, setLoading] = React.useState(false);
  const [tab, setTab] = React.useState(TAB_GENERAL);
  const { generalSetting, setGeneralSetting } = useGeneralSetting();
  const { currentUser } = useAuth();
  const { sensorGroups } = useSensorGroups();
  const { notifications } = useNotifications()
  const [modifyingGroup, setModifyingGroup] = React.useState(null);
  const [modifyingNotification, setModifyingNotification] = React.useState(null);
  const { emergencyRoutes, setEmergencyRoutes } = useGeoCoordinate();
  const [localEmergencyRoutes, setLocalEmergencyRoutes] = React.useState([]);

  // Create tabs array based on user accountType
  const TABS = React.useMemo(() => {
    const tabs = [TAB_GENERAL, TAB_MESSAGE, TAB_NOTIFICATION];
    if (currentUser?.accountType === 'ADMIN') {
      tabs.push(TAB_EMERGENCY_ROUTE);
    }
    return tabs;
  }, [currentUser?.accountType]);

  // Sync local state with global state when emergency routes change
  React.useEffect(() => {
    setLocalEmergencyRoutes(emergencyRoutes);
  }, [emergencyRoutes]);

  /*** Processing ***/
  /*** Sub Components ***/
  const renderGeneralSetting = () => {
    return <ModifyGeneralSettingForm
      initSetting={generalSetting || {}}
      onSubmit={onUpdateGeneralSetting} />
  }

  const renderGroupSetting = () => {
    return <div
      style={{ padding: modifyingGroup ? '0 16px' : '0' }}
      className='master_management_page_subnav_content_container'>
      {renderCreateGroupForm()}
    </div>
  }

  const renderCreateGroupForm = () => {
    if (modifyingGroup) {
      return <ModifyGroupForm
        group={modifyingGroup}
        onCancel={() => { setModifyingGroup(null) }}
        onModify={onModifyGroup} />
    }
    return <>
      <div
        style={{ justifyContent: 'flex-end' }}
        className='master_management_page_list_actions_container'>
        <button
          className='button_active'
          onClick={() => { setModifyingGroup({}) }}>
          {TEXT_CREATE_NEW}
        </button>
      </div>
      <div className='master_management_page_list_container'>
        <SensorGroupList
          items={sensorGroups}
          onClick={(item) => { setModifyingGroup(item) }}
          onDelete={onDeleteGroup} />
      </div>
    </>
  }

  const renderNotification = () => {
    return <div style={{ padding: modifyingNotification ? '0 16px' : '0' }}
      className='master_management_page_subnav_content_container'>
      {modifyingNotification ? (
        <ModifyNotificationForm
          notification={modifyingNotification}
          onCancel={() => setModifyingNotification(null)}
          onModify={onModifyNotification}
        />
      ) : (
        <>
          <div
            style={{ justifyContent: 'flex-end' }}
            className='master_management_page_list_actions_container'>
            <button
              className='button_active'
              onClick={() => { setModifyingNotification({}) }}>
              {TEXT_CREATE_NEW}
            </button>
          </div>
          <div className='master_management_page_list_container'>
            <NotificationList
              items={notifications}
              onClick={(item) => { setModifyingNotification(item) }}
              onDelete={onDeleteNotification} />
          </div>
        </>
      )}
    </div>
  }

  const renderEmergencyRoute = () => {
    return <div className='master_management_page_subnav_content_container'>
      <div className="emergency_route_page_wrapper">
        <EmergencyRouteUpload onUpload={onUploadEmergencyRouteCSV} />
        <EmergencyRouteList
          items={localEmergencyRoutes}
          onDelete={onDeleteEmergencyRoute}
          onSave={onSaveEmergencyRoutes}
          onColorChange={onChangeRouteColor}
          onReorder={onReorderEmergencyRoutes}
        />
      </div>
    </div>
  }

  /*** Event Handlers ***/
  const onUpdateGeneralSetting = async (data) => {
    if (!loading) {
      setLoading(true);
      const newData = { ...generalSetting, ...data };
      try {
        await uploadData({
          key: 'setting/general_setting.json',
          data: JSON.stringify(newData),
          options: {
            level: "public",
            contentType: "text/plain",
          }
        });
        setGeneralSetting(newData);
        success(DIALOG_MESSAGE_UPDATED_GENERAL_SETTING_SUCCESSFULLY);
      }
      catch (e) {
        error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
      }
      setLoading(false);
    }
  }
  const onModifyGroup = async (newGroup) => {
    if (!newGroup.name) {
      error("グループ名を入力していません！");
      return;
    }
    if (!loading) {
      setLoading(true);
      if (!modifyingGroup.id) {
        const result = await apiCreateGroup(newGroup);
        if (result.success) {
          success("センサグループを作成しました。");
          setModifyingGroup(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      else {
        delete newGroup.updatedAt;
        delete newGroup.createdAt;
        const result = await apiUpdateGroup(newGroup);
        if (result.success) {
          success("センサグループを更新しました。");
          setModifyingGroup(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      setLoading(false);
    }
  }

  const onDeleteGroup = async (item) => {
    warningConfirm(
      DIALOG_MESSAGE_CONFIRM_DELETE_GROUP,
      async () => {
        const result = await apiDeleteGroup(item.id);
        if (!result.success) {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      },
      {}
    );
  }

  const onModifyNotification = async (newNotification) => {
    if (!loading) {
      setLoading(true);
      if (!modifyingNotification.id) {
        const result = await apiCreateNotification(newNotification);
        if (result.success) {
          success(DIALOG_MESSAGE_CREATED_NOTIFICATION_SUCCESSFULLY);
          setModifyingNotification(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      else {
        delete newNotification.updatedAt;
        delete newNotification.createdAt;
        const result = await apiUpdateNotification(newNotification);
        if (result.success) {
          success(DIALOG_MESSAGE_UPDATED_NOTIFICATION_SUCCESSFULLY);
          setModifyingNotification(null);
        }
        else {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      }
      setLoading(false);
    }
  }

  const onDeleteNotification = async (item) => {
    warningConfirm(
      DIALOG_MESSAGE_CONFIRM_DELETE_NOTIFICATION,
      async () => {
        const result = await apiDeleteNotification(item.id);
        if (!result.success) {
          error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
        }
      },
      {}
    );
  }

  const onUploadEmergencyRouteCSV = async (file) => {
    setLoading(true);
    try {
      const result = await apiUploadEmergencyRouteCSV(file);

      if (result.success) {
        const routesMap = result.routesMap;

        // Create a map of existing routes by routeName for quick lookup
        const existingRoutesMap = new Map(
          localEmergencyRoutes.map(route => [route.routeName, route])
        );

        // Convert new routes to array format
        const newRoutes = Object.keys(routesMap).map((routeName, index) => {
          const existingRoute = existingRoutesMap.get(routeName);

          if (existingRoute) {
            // Update existing route - keep its order and color, update coordinates and fileName
            return {
              ...existingRoute,
              fileName: result.fileName,
              coordinates: routesMap[routeName]
            };
          } else {
            // Create new route with black default color - displayOrder will be recalculated later
            return {
              id: `route-${Date.now()}-${index}`,
              fileName: result.fileName,
              routeName: routeName,
              displayOrder: 0, // Temporary value
              color: '#fff',
              coordinates: routesMap[routeName]
            };
          }
        });

        // Merge: Keep existing routes not in new upload, update/add new routes
        const updatedRoutesMap = new Map(
          localEmergencyRoutes.map(route => [route.routeName, route])
        );

        newRoutes.forEach(route => {
          updatedRoutesMap.set(route.routeName, route);
        });

        const finalRoutes = Array.from(updatedRoutesMap.values());

        // Recalculate displayOrder for all routes based on actual position
        finalRoutes.forEach((route, index) => {
          route.displayOrder = index + 1;
        });

        setLocalEmergencyRoutes(finalRoutes);
        success(DIALOG_MESSAGE_EMERGENCY_ROUTE_UPLOADED);
      } else {
        console.error('Upload failed:', result.error);
        error(DIALOG_ERROR_EMERGENCY_ROUTE_UPLOAD);
      }
    } catch (e) {
      console.error('Upload error:', e);
      error(DIALOG_ERROR_EMERGENCY_ROUTE_UPLOAD);
    }
    setLoading(false);
  };

  const onDeleteEmergencyRoute = (item, index) => {
    // Calculate total number of coordinates (data points)
    let totalCoordinates = 0;
    if (item.coordinates && Array.isArray(item.coordinates)) {
      item.coordinates.forEach(group => {
        if (Array.isArray(group)) {
          totalCoordinates += group.length;
        }
      });
    }

    const message = `ファイルに含まれる輸送データ（${totalCoordinates}件）もシステムから削除されます。よろしいですか？`;

    warningConfirm(
      message,
      () => {
        const newRoutes = localEmergencyRoutes.filter((_, i) => i !== index);
        // Reorder display order
        newRoutes.forEach((route, i) => {
          route.displayOrder = i + 1;
        });
        setLocalEmergencyRoutes(newRoutes);
      },
      {}
    );
  };

  const onSaveEmergencyRoutes = async () => {
    // Validate maximum 5 routes
    if (localEmergencyRoutes.length > 5) {
      error(DIALOG_ERROR_EMERGENCY_ROUTE_MAX_LIMIT);
      return;
    }

    setLoading(true);
    try {
      // Save the full array with all information
      const result = await apiSaveEmergencyRoutes(localEmergencyRoutes);

      if (result.success) {
        success(DIALOG_MESSAGE_EMERGENCY_ROUTE_SAVED);
        // Refresh global state
        setEmergencyRoutes(localEmergencyRoutes);
      } else {
        console.error('Save failed:', result.error);
        error(DIALOG_ERROR_EMERGENCY_ROUTE_SAVE);
      }
    } catch (e) {
      console.error('Save error:', e);
      error(DIALOG_ERROR_EMERGENCY_ROUTE_SAVE);
    }
    setLoading(false);
  };

  const onChangeRouteColor = (index, color) => {
    const newRoutes = [...localEmergencyRoutes];
    newRoutes[index].color = color;
    setLocalEmergencyRoutes(newRoutes);
  };

  const onReorderEmergencyRoutes = (reorderedItems) => {
    setLocalEmergencyRoutes(reorderedItems);
  };

  /*** Main Render ***/
  return <div className='master_management_page_container'>
    <div className='master_header'>
      <label className='header-text' style={{ fontWeight: 900 }}>{TEXT_MASTER_MANAGEMENT}</label>
      <NavBar
        tabs={TABS}
        currentTab={tab}
        onTabChange={setTab} />
      <label className='master_management_page_version'>Version 1.6</label>
    </div>

    <div className='master_management_page_nav_content'>
      {tab === TAB_GENERAL ? renderGeneralSetting() : tab === TAB_MESSAGE ? renderGroupSetting() : tab === TAB_NOTIFICATION ? renderNotification() : renderEmergencyRoute()}
    </div>
    {loading ? <FanLoadingIcon size={80} /> : null}
  </div>;
}
MasterManagementPage.propTypes = propTypes;
MasterManagementPage.defaultProps = defaultProps;
export default MasterManagementPage;